// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import uniq from "lodash/uniq";
import without from "lodash/without";

/**
 * To generate className string after add/remove classNames
 */
export const xClassNames = {
    append: (value?: string | boolean | undefined | (string | undefined | boolean)[], prevClassName?: string) => {
        let valueAsArray = value ? (Array.isArray(value) ? value : [value]) : [];
        valueAsArray = valueAsArray.filter(item => !!item);
        const prevClassNameAsArray = (prevClassName || "").trim().split(" ");
        return uniq([...prevClassNameAsArray, ...valueAsArray])
            .join(" ")
            .trim();
    },
    remove: (value?: string | undefined | (string | undefined | boolean)[], prevClassName?: string) => {
        let valueAsArray = value ? (typeof value === "string" ? [value] : value) : [];
        valueAsArray = valueAsArray.filter(item => !!item);
        const prevClassNameAsArray = (prevClassName || "").trim().split(" ");
        return uniq(without(prevClassNameAsArray, ...valueAsArray))
            .join(" ")
            .trim();
    },
};
